import { useMemo } from "react";

import FormGroup from "@/design/forms/FormGroup";

import { Grid, Stack } from "@mui/material";
import PropTypes from "prop-types";

import LineKeyTemplateAccount from "./LineKeyTemplateAccount";

function LineKeyTemplateAccounts({ user, dispatch }) {
  const lineKeyTemplatePositions = useMemo(() => {
    return Array.from(
      { length: 7 },
      (_, position) => user.lineKeyTemplateAccounts.find((account) => account.position === position) ?? { position },
    );
  }, [user.lineKeyTemplateAccounts]);

  return (
    <FormGroup title="Line keys">
      <Grid size={12}>
        <Stack
          sx={{
            gap: 1,
          }}
        >
          {lineKeyTemplatePositions.map((item, key) => {
            if (
              item?.id === undefined &&
              lineKeyTemplatePositions.findIndex((template) => template?.id === undefined) === key
            ) {
              return <LineKeyTemplateAccount key={key} lineKeyTemplateAccount={item} user={user} dispatch={dispatch} />;
            } else if (item?.id !== undefined) {
              return (
                <LineKeyTemplateAccount key={item.id} lineKeyTemplateAccount={item} user={user} dispatch={dispatch} />
              );
            }
          })}
        </Stack>
      </Grid>
    </FormGroup>
  );
}

LineKeyTemplateAccounts.propTypes = {
  user: PropTypes.object,
  dispatch: PropTypes.func,
};

export default LineKeyTemplateAccounts;
